export const SUPPORTED_LANGUAGES = {
    NB: 'nb',
    NN: 'nn',
    EN_GB: 'en-GB',
} as const;

export const DEFAULT_LANGUAGE = SUPPORTED_LANGUAGES.NB;

export type SupportedLanguage =
    (typeof SUPPORTED_LANGUAGES)[keyof typeof SUPPORTED_LANGUAGES];

export const LANGUAGE_CODES: Record<SupportedLanguage, string> = {
    [SUPPORTED_LANGUAGES.NB]: 'Norwegian bokmål (NB)',
    [SUPPORTED_LANGUAGES.NN]: 'Norwegian nynorsk (NN)',
    [SUPPORTED_LANGUAGES.EN_GB]: 'English (UK)',
};

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
    [SUPPORTED_LANGUAGES.NB]: 'Norsk bokmål',
    [SUPPORTED_LANGUAGES.NN]: 'Norsk nynorsk',
    [SUPPORTED_LANGUAGES.EN_GB]: 'English (UK)',
};
